<div fxLayout="column" fxLayoutAlign="center" id="dialog">
  <button mat-icon-button
    mat-dialog-close
    class="close-dialog">
    <mat-icon>close</mat-icon>
  </button>

  <h3 mat-dialog-title [ngClass]="getClass(issue.issueStatus)+'-bg'">{{issue.issueTitle}}</h3>

  <div class="mat-dialog-title-content">
    <div id="affectedServices" style="display: flex;">
      <div class="subtitle-1"> Affected Services  </div>
      <div>
        <ul>
          @for (service of affectedServices; track service) {
            <li>{{service.serviceAlias}}</li>
          }
        </ul>
      </div>
    </div>
    <mat-divider></mat-divider>
    <div  id="historydiv">
      @for (issueUpdate of issueUpdates; track issueUpdate) {
        <div>
          <p>
            <b [ngClass]="getClass(issueUpdate.issueState || issue.issueState)">{{issueUpdate.issueState || issue.issueState}}</b> - {{issueUpdate.issueComment}}
            <br>
              <span class="small-text">Posted on {{issueUpdate.updateDate | date : "MM/dd/yy HH:mm"}}.</span>
            </p>
            <mat-divider></mat-divider>
          </div>
        }
      </div>
    </div>
  </div>

